import { dialogs } from '@Containers/Dialogs/DialogsSelectors';

export function showMore (state, ownProps) {
  const { id } = ownProps;

  return dialogs(state).getIn([id, 'showMore']);
}
